"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMetaFile = void 0;
function isMetaFile(file) {
    if (file instanceof File) {
        return ['text/csv', 'text/tsv', 'text/plain'].includes(file?.type);
    }
    const extension = file?.name?.replace(/^.*\./, '').toLowerCase();
    return ['csv', 'tsv', 'text'].includes(extension);
}
exports.isMetaFile = isMetaFile;
